import { useTranslation } from 'next-i18next'
import React from 'react'

import { BeltVisual } from '@goodfellas/belt-visual'
import { Colors } from '@goodfellas/graduation'

import FighterPhone from './fighterPhone'

interface FighterInfoProps {
  name: string
  belt: string
  beltDegree: number
  phone: string
  type: string
}

export default function FighterInfo({
  name,
  belt,
  beltDegree,
  phone,
  type,
}: FighterInfoProps) {
  const { t } = useTranslation('avaliacao360')
  const resolvedBelt: Colors = (Object.values(Colors) as string[]).includes(
    belt,
  )
    ? (belt as Colors)
    : Colors.White
  return (
    <div className="mt-8 mb-2 cursor-default text-white">
      <div className="flex flex-row justify-start gap-x-4 items-center">
        <h2 className="text-4xl">{name}</h2>
      </div>
      <div
        id="fighter-headline"
        className="flex flex-row justify-between h-fit text-sm uppercase mt-2"
      >
        <div className="flex flex-row justify-start items-center gap-x-3 w-1/2">
          <BeltVisual color={resolvedBelt} degree={beltDegree || 0} size="md" />

          <span className="px-3 py-1 h-fit font-bold text-xs rounded-full border-1 border-white/20">
            {t(`table.types.${type}`)}
          </span>
        </div>
        <FighterPhone phone={phone} />
      </div>
    </div>
  )
}
